// extracted by mini-css-extract-plugin
export default {"tooltipContent":"radixTooltip_tooltipContent__uxHPx","tooltipArrow":"radixTooltip_tooltipArrow__vN2te"};